import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faServer, 
    faLaptopCode, 
    faUserTie 
} from '@fortawesome/free-solid-svg-icons';
import './ServiceIcon.css';

const ServiceIcon = ({ index }) => {
    const icons = [
        { icon: faServer, title: 'Infrastructure' },
        { icon: faLaptopCode, title: 'Solutions Digitales' },
        { icon: faUserTie, title: 'Conseil' }
    ];

    return (
        <div className="service-icon-wrapper">
            <FontAwesomeIcon
                icon={icons[index].icon}
                className="service-icon"
                title={icons[index].title}
            />
        </div>
    );
};

export default ServiceIcon;